<template>
  <EmailComponentsPtAccountPercent />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
